import { useState } from "react";
import PlanSetup from "./PlanSetup";
import ExceptionalMenuRequisitionDetails from "./ExceptionalMenuRequisitionDetails";

const ExceptionalMenuRequisition = () => {
  const [open, setOpen] = useState<boolean>(false);
  const handleClick = (): void => {
      setOpen(true);
  };  
  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Exceptional Menu Requisition
      </h1>
      <PlanSetup handleClick={handleClick}/>
      {open && 
        <ExceptionalMenuRequisitionDetails />
      }      
    </div>    
  );
};

export default ExceptionalMenuRequisition;
